import { render, staticRenderFns } from "./TabsSimple.vue?vue&type=template&id=d46d1378&scoped=true&"
import script from "./TabsSimple.vue?vue&type=script&lang=js&"
export * from "./TabsSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46d1378",
  null
  
)

export default component.exports